import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapCoachesComponent } from './components/bootstrap-coaches/bootstrap-coaches.component';

const routes: Routes = [
  {path:'', component:BootstrapCoachesComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoachesRoutingModule { }
